import { Partner } from '../partner';

export interface RegistrationState {
  manager: Partner | null;
  managerLoading: boolean;
  loading: boolean;
}

export const initialRegistrationState: RegistrationState = {
  managerLoading: true,
  loading: false,
  manager: null,
};
